<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="3">
        <SystemNavigations>
          <template v-slot:append-inner>
            <language-selector v-model="currentLang" light />
          </template>
        </SystemNavigations>
      </v-col>
      <v-col cols="12" lg="9">
        <v-toolbar color="secondary" dark height="45" rounded>
          <v-toolbar-title class="text-body-1">
            <v-icon left class="mr-2" size="20">mdi-cog-box</v-icon>
            {{ option.name }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card>
          <v-progress-linear v-if="inputListLoading" indeterminate color="primary"></v-progress-linear>
          <v-row class="mx-0 px-2">
            <v-col cols="12" lg="5">
              <ListInputs :inputs="inputs" @input="inputData" />
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12">
              <v-btn color="blue" small dark :loading="loading" @click="updateInputList">
                <v-icon left>mdi-refresh</v-icon>
                {{ $t("PANEL.OPTION.UPDATE_INPUT_BTN") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SystemNavigations from "@/components/Settings/SystemSettings/OptionNavigation.vue";
import ListInputs from "@/components/Settings/SystemSettings/ListInputs.vue";
import LanguageSelector from "@/components/Base/LanguageSelector.vue";

export default {
  name: "SystemSetting",
  data() {
    return {
      inputs: [],
      option: [],
      defaultOption: "genel",
      currentLang: null,
      loading: false,
      inputListLoading: true
    };
  },
  components: {
    LanguageSelector,
    SystemNavigations,
    ListInputs
  },
  methods: {
    updateInputList() {
      const optionSysName = this.option.sysname,
        inputList = this.option.inputs;

      this.loading = true;

      this.$store
        .dispatch("Option/ApiOptions/updateInputList", {
          optionSysName,
          inputList
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("PANEL.OPTION.NOTIFY.UPDATE_INPUT_SUCCESS", { OPTION: this.option.name }), this.$t("PANEL.NOTIFY.SUCCESS"));
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .finally(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    inputData(data) {
      this.option.inputs = data;
    },
    getOption(optionSysName, currentLang = null) {
      const lang = currentLang || this.$store.state.Language.apiLanguage;

      this.inputListLoading = true;
      this.$store
        .dispatch("Option/ApiOptions/option", { optionSysName, lang })
        .then(res => {
          this.option = res.data;
          this.inputs = res.data.inputs;
        })
        .finally(() => {
          this.inputListLoading = false;
        })
        .catch(() => {
          this.inputListLoading = false;
        });
    }
  },
  created() {
    /**
     *  Giriş yoksa genel ayarları getir,
     *  varsa sysname ile input listesini getir
     */
    this.getOption(this.$route.params.optionSysName ?? this.defaultOption);
  },
  watch: {
    $route() {
      this.getOption(this.$route.params.optionSysName);
    },

    currentLang() {
      this.getOption(this.$route.params.optionSysName ?? this.defaultOption, this.currentLang.code);
    }
  }
};
</script>

<style></style>
